/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useMemo, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Select from 'react-select';
import {connect} from 'react-redux';
import {
  DropdownIndicator,
  customStyles,
  PrimaryButton,
  Modal,
} from '../../../components';
import {plus} from '../../../assets/images/images';
import * as Actions from '../../../store/actions';
import AssignApps from './AssignApps';

function InviteMemberModal({
  open,
  setOpen,
  roles,
  inviteTeamMember,
  loading,
  getAllApps,
  apps: {allApps},
}) {
  const navigate = useNavigate();

  const roleOptions = useMemo(
    () =>
      roles
        ? roles
            .filter(r => r.role !== 'Owner')
            .map(r => ({value: r.role, label: r.role}))
        : null,
    [roles],
  );

  const userApps = useMemo(
    () =>
      allApps
        ? allApps?.apps?.map(app => ({value: app._id, label: app.name}))
        : [],
    [roles],
  );

  const DATA = [{label: 'Select All', value: 'all'}, ...(userApps || [])];
  const [selectedRole, setSelectedRole] = useState();
  const [selectedApps, setSelectedApps] = useState({});
  const [email, setEmail] = useState('');

  useEffect(() => {
    getAllApps({limit: '500'});
  }, [getAllApps, DATA.length]);

  const handleAddNewRole = () => {
    setOpen(false);
    navigate('/settings/team/owner', {state: {triggerAddRole: true}});
  };

  const handleSubmit = async e => {
    e.preventDefault();
    await inviteTeamMember(
      {
        email,
        role: selectedRole.value,
        ...(selectedApps?.pullApps?.length !== 0 && {
          apps: selectedApps?.pushApps,
        }),
      },
      () => setOpen(false),
    );
  };

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Invite a member"
    >
      <form className="text-left">
        <div className="px-6">
          <label htmlFor="dui" className="mt-6">
            <span className="text-sm ">Email address</span>
            <input
              type="email"
              id="dui"
              className="mt-2"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="example@gmail.com"
              required
            />
          </label>

          <label htmlFor="role" className="mt-6 mb-2">
            Role
          </label>
          <Select
            defaultValue={selectedRole}
            onChange={setSelectedRole}
            options={roleOptions}
            components={{DropdownIndicator}}
            classNamePrefix="react-select"
            styles={customStyles}
            menuPlacement="auto"
          />
          <button
            className="flex items-center gap-[2px] ml-auto mt-2"
            type="button"
            onClick={handleAddNewRole}
          >
            <img src={plus} alt="" width={12} height={12} />
            <span className="text-xs font-medium text-body">Add new role</span>
          </button>
          <AssignApps
            setAppsToAssign={data => {
              setSelectedApps(data);
            }}
          />
        </div>
        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <PrimaryButton
            buttonText="Send invite"
            className="w-full !h-10"
            loading={loading}
            onClick={handleSubmit}
          />
        </div>
      </form>
    </Modal>
  );
}

export default connect(state => state, Actions)(InviteMemberModal);
